import { MAPPING_PROPS } from "./index.model"

export const DECISION_TYPE = {
  PAY: 'PAY',
  RETURN: 'RETURN',
}

export enum TRANSACTION_TYPE {
  ALL = 0,
  ACH = 1,
  CHECK = 2,
}

export enum DECISION_CODE {
  PAY = 0,
  RETURN = 1,
}

export const EXCEPTION_STATUS = {
  PAID: 'paid',
  RETURNED: 'returned',
  EXCEPTION: 'exception',
  PROCESSING: 'processing',
}

export const EXCEPTION_STATUS_KEYS = {
  PAID: 'PAID',
  RETURNED: 'RETURNED',
  EXCEPTION: 'EXCEPTION',
  PROCESSING: 'PROCESSING',
}


export const CheckExceptionDefault = {
  id: '',
  exceptionType: '',
  amount: '',
  exceptionStatus: '',
  defaultDecision: '',
  exceptionDate: '',
  reason: '',
  decisionDueDate: '',
  cutoffTime: '',
  accountName: '',
  paidDate: '',
  issuedDate: '',
  checkNumber: '',
  issuedAmount: 0,
  issuedPayee: '',
  frontImagePath: '',
  backImagePath: '',
  decisionedBy: '',
  decisionTime: '',
  clientId: '',
  accountId: '',
  otherReason: '',
  allReasons: '',
  reasons: [],
  decision: '',
  overdue: false
}

export const REASON_MAPPING: MAPPING_PROPS = {
  AMT: 'Amount Mismatch',
  STALE: 'Stale Dated',
  OTHER: 'Other',
  PDIP: 'Past Deadline Item Paid',
  ALT: 'Altered/Fictitious Item',
  DUP: 'Duplicate',
  ENDORS: 'Endorsement Issue',
  FRAUD: 'Fraudulent',
  IMPSIGN: 'Improper Signature',
  POSTDT: 'Post Dated',
  UNAUTH: 'ACH Unauthorized Transaction',
  PDIR: 'Past Deadline Item Returned',
}

export const EXCEPTION_CHECK_TYPE_MAPPING: MAPPING_PROPS = {
  NCI: 'No Check Image',
  PNI: 'Paid Not Issued',
  AMT: 'Amount Mismatch',
  DPI: 'Duplicate Paid Item',
  PMAN: 'Payee Match Additional Name',
  PMOL: 'Payee Match Over Amount Limit',
  PNM: 'Payee Name Mismatch',
  SDI: 'Stale Dated Item',
  VOID: 'Voided Item',
  ZERO: 'Check Number is Zero'
}

export const EXCEPTION_ACH_TYPE_MAPPING: MAPPING_PROPS = {
  UACHT: 'Unauthorized ACH Transaction'
}

export const AchExceptionDefault = {
  id: '',
  exceptionType: '',
  amount: '',
  exceptionStatus: '',
  defaultDecision: '',
  exceptionDate: '',
  reason: '',
  decisionDueDate: '',
  cutoffTime: '',
  accountName: '',
  paidDate: '',
  secCode: '',
  achOriginatorID: '',
  debitOrCredit: '',
  transactionDescription: '',
  transactionCode: '',
  decision: '',
  decisionedBy: null,
  decisionTime: null,
  clientId: '',
  accountId: '',
  otherReason: '',
  allReasons: '',
  reasons: [],
  overdue: false
}
